import styled from "@emotion/styled";
import { Box, Checkbox, Chip, Radio, Typography } from "@mui/material";
import {
  laptop,
  mediumMobile,
  mobile,
  smallMobile,
  tablet,
} from "commons/styled.components";

export const SurveyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-grow: 1;
  padding: 2rem;

  ${tablet(`
    padding: 1.5rem;
  `)}

  ${mobile(`
    padding: 1rem;
  `)}

  ${smallMobile(`
    padding: 0.75rem;
  `)}
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  margin-top: 2rem;
  width: 100%;
  align-items: center;

  ${mobile(`
    margin-top: 1.5rem;
    gap: 0.5rem;
  `)}

  ${smallMobile(`
    margin-top: 1rem;
  `)}
`;

export const SurveyQuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 1rem;

  ${mobile(`
    padding: 0 0.5rem;
  `)}
`;

export const SurveyQuestions = styled(Typography)`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  text-align: center;

  ${tablet(`
    font-size: 22px;
  `)}

  ${mobile(`
    font-size: 20px;
  `)}

  ${smallMobile(`
    font-size: 18px;
  `)}
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 0px;
  margin-top: 2rem;
  gap: 32px;
  width: 100%;

  ${tablet(`
    gap: 24px;
    margin-top: 1.5rem;
  `)}

  ${mobile(`
    gap: 16px;
    margin-top: 1rem;
  `)}

  ${smallMobile(`
    gap: 12px;
  `)}
`;

export const EachOption = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 8px;
  min-width: 202px;
  min-height: 60px;
  border: 1px solid #afafaf;
  border-radius: 4px;

  ${laptop(`
    min-width: 180px;
  `)}

  ${tablet(`
    min-width: 160px;
    font-size: 14px;
  `)}

  ${mobile(`
    min-width: 140px;
    min-height: 50px;
    font-size: 13px;
    flex: 1 1 calc(50% - 16px);
    max-width: calc(50% - 16px);
  `)}

  ${mediumMobile(`
    min-width: 120px;
    padding: 8px;
    gap: 6px;
  `)}

  ${smallMobile(`
    min-width: 100%;
    max-width: 100%;
    flex: 1 1 100%;
  `)}
`;

export const CheckBox = styled(Checkbox)`
  /* Radio button */
  width: 18px;
  height: 18px;
  border-radius: 4px;
  color: #158a73;
  &.Mui-checked {
    color: #158a73;
  }

  ${mobile(`
    width: 16px;
    height: 16px;
  `)}
`;

export const RadioBox = styled(Radio)`
  /* Radio button */
  width: 18px;
  height: 18px;
  border-radius: 4px;
  color: #158a73;
  &.Mui-checked {
    color: #158a73;
  }

  ${mobile(`
    width: 16px;
    height: 16px;
  `)}
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  width: 100%;

  ${mobile(`
    gap: 0.75rem;
    margin-top: 1.5rem;
  `)}

  ${smallMobile(`
    flex-direction: column;
    gap: 0.5rem;
  `)}
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  gap: 0.75rem;

  ${mobile(`
    margin-top: 1rem;
  `)}
`;

export const SelectedChip = styled(Chip)`
  background-color: #158a73;
  color: white;
  padding-top: 2px;
  && .MuiChip-deleteIcon {
    color: white;
  }
  max-width: 200px;
  & .MuiChip-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  padding-left: 0.5rem;
  margin-top: 1rem;

  ${mobile(`
    gap: 0.25rem;
  `)}
`;

export const AllOptionsSelectedMessage = styled(Box)`
  margin-top: 1rem;
  color: #555;
  background-color: #f0f0f0;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-style: italic;
`;
